/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxAlertsTabAction,
    CashBoxAlertsTabActionType,
    fetchCashBoxAlertsHistorySuccessAction,
    fetchCashBoxAlertsHistoryErrorAction,
    downloadAlertsHistorySuccessAction,
    downloadAlertsHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxAlertsTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxAlertsHistoryEpic: Epic<CashBoxAlertsTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxAlertsTabActionType.FETCH_CASHBOX_ALERTS_HISTORY),
        switchMap((action) => {
            const params = action.payload;
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const listName = i18n.t('RegistryScreens.cashBoxAlertsHistory').toLowerCase();

            return from(cashboxesClient.getCashBoxAlertsHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashBoxAlertsHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxAlertsHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(CashBoxAlertsTabActionType.EXIT_CASHBOX_ALERTS_TAB)),
            );
        }),
    );
};

export const cashBoxAlertsHistoryDownloadEpic: Epic<CashBoxAlertsTabAction> = (actions$, state$) => {
    return actions$.pipe(
        ofType(CashBoxAlertsTabActionType.DOWNLOAD_ALERTS_HISTORY),
        exhaustMap((action) => {
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const fileName = `cashbox_${taxNumber}_AlertsHistory.xls`;

            return from(cashboxesClient.downloadCashBoxAlertsHistoryAsExcel(taxNumber, action.payload)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),
                mapTo(downloadAlertsHistorySuccessAction()),
                catchError((err: AxiosError) =>
                    of(
                        downloadAlertsHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
